import React from 'react';
import { Link } from 'react-router-dom';

export default function MyBucks({
  totalBucksCount = 0,
  totalBucksValue = 0,
  closeDrawer = () => {}
}) {
  return (
    <div className="my-buckes">
      <div className="balances mb-4">
        <div className="bal">
          <span>Total RWA Bucks in my collection</span>
          <span className="amount">{totalBucksCount || '0'}</span>
        </div>
        {totalBucksCount ? (
          <div className="collecton px-4 pt-4">
            <div className="images">
              <img src={require('./Images/NFTBucks-Dummy-Group.webp')} alt="" />
            </div>
            <div className="details">
              <div className="amount">${totalBucksValue || '0'}</div>
              <Link
                to="/StakeHub/MyCollection"
                onClick={() => closeDrawer(true)}
                className="collection-link"
              >
                Go to my collection
              </Link>
              <Link
                to="/MarketHub/NFTBucksMarket"
                onClick={() => closeDrawer(true)}
                className="more-link"
              >
                Get more bucks
              </Link>
            </div>
          </div>
        ) : (
          <div className="collecton px-4 pt-4 no-bucks">
            <div className="images">
              <img src={require('./Images/NFTBucks-Dummy-Group.webp')} alt="" />
            </div>
            <div className="details">
              <div className="no-bucks-msg">
                You don’t own any NFT bucks yet!
              </div>
              <Link
                to="/MarketHub/NFTBucksMarket"
                onClick={() => closeDrawer(true)}
                className="more-link opacity-100"
              >
                Get bucks
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
